import { Link } from "react-router-dom";
import { mediaItems } from "../data/mediaItems";
import VideoGrid from "./VideosGrid";
import './Education.scss';

const MediaShowcase = () => {
  return (
    <section id="education" className="media-showcase">
      <div className="container">
        <div className="header">
          <h2>See our platform in action</h2>
          <p>Get a live preview of our trading platform.</p>
        </div>
        
        <VideoGrid videos={mediaItems.slice(0, 3)} />
        
        {mediaItems.length > 3 && (
          <div className="view-more">
            <Link to="/videos" className="button">
              View all videos
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default MediaShowcase;